import { get, map } from 'lodash';
import { useMemo } from 'react';
import { permissionList } from 'src/config';
import { checkIncludes } from 'src/utils/check-includes';
import { useAuth } from './use-auth';

export function usePermission(permissionChecks = {}) {
  const {
    user: { permissions }
  } = useAuth();

  return useMemo(() => {
    // Tạo đối tượng kết quả
    return map(permissionChecks, (permission, key) => ({
      [key]: checkIncludes(permissions.access, get(permissionList.access, permission))
    })).reduce((acc, curr) => ({ ...acc, ...curr }), {}); // Gộp các key-value thành một đối tượng
  }, [permissionChecks, permissions]);
}
